import React from "react";
import { useNavigate } from "react-router";
import Button from "../../../components/button";
import DocumentPage from "../../../components/document-page";
import styles from '../styles.module.css';
import { HelpLink } from "../../../common/help";

function PrivacePolicyPage() {
  const navigation = useNavigate();

  const handleClickPrevPage = () => {
    navigation('/account');
  }

  return (
       <DocumentPage variant="scrollable" className="policy-container">
        <h1>Политика конфиденциальности | OpenWay</h1>
        <hr/>
        <div className="date-info">
            <p>Настоящая Политика обработки персональных данных (далее — «Политика») разработана в соответствии с требованиями действующего законодательства Российской Федерации о персональных данных и определяет порядок обработки, хранения, защиты и использования информации, которую сервис Openway (далее — «Сервис», «Мы», «Openway») может получить о пользователях (далее — «Пользователь», «Вы»).</p>
        </div>

        <div className="highlight">
            <p><strong>Важно:</strong> Использование Сервиса означает согласие Пользователя с условиями настоящей Политики и условиями обработки его персональных данных.</p>
        </div>

        <div className="section">
            <h2>1. Основные понятия</h2>
            <p>В настоящей Политике используются следующие понятия:</p>
            <ul>
                <li><strong>Персональные данные</strong> — любая информация, прямо или косвенно относящаяся к определенному или определяемому Пользователю.</li>
                <li><strong>Обработка персональных данных</strong> — сбор, запись, систематизация, накопление, хранение, использование, передача и иные действия с данными.</li>
                <li><strong>Оператор</strong> — юридическое лицо, самостоятельно или совместно с другими лицами организующее и/или осуществляющее обработку персональных данных и определяющее цели обработки.</li>
            </ul>
        </div>

        <div className="section">
            <h2>2. Состав персональных данных</h2>
            <p>Мы можем собирать и обрабатывать следующие данные:</p>
            
            <h3>2.1 Данные, предоставляемые Пользователем:</h3>
            <ul>
                <li>Telegram ID, username</li>
                <li>Контактная информация (если предоставляется)</li>
                <li>Выбранные тарифы и параметры подписки</li>
            </ul>

            <h3>2.2 Технические данные:</h3>
            <ul>
                <li>Дата регистрации в Сервисе</li>
                <li>Дата начала и окончания подписки</li>
                <li>Идентификатор устройства или ключ</li>
                <li>Ограниченные служебные данные, необходимые для функционирования</li>
            </ul>

            <h3>2.3 Платёжная информация:</h3>
            <ul>
                <li>Данные о факте оплаты и сумме через платёжные системы</li>
            </ul>
            <div className="highlight">
                <p><strong>Примечание:</strong> Сервис не хранит данные банковских карт — обработка платежей осуществляется через сторонние платёжные платформы.</p>
            </div>
        </div>

        <div className="section">
            <h2>3. Цели обработки данных</h2>
            <p>Персональные данные обрабатываются в следующих целях:</p>
            <ul>
                <li>Обеспечение доступа к услугам Сервиса</li>
                <li>Управление подпиской</li>
                <li>Обработка и подтверждение платежей</li>
                <li>Обеспечение технической поддержки</li>
                <li>Уведомление о статусе услуг</li>
                <li>Выполнение требований законодательства</li>
            </ul>
        </div>

        <div className="section">
            <h2>4. Принципы и условия обработки</h2>
            <p>Обработка данных осуществляется на законной, справедливой основе с соблюдением целей, определённых настоящей Политикой.</p>
            <p>Мы обрабатываем персональные данные только при наличии одного из оснований:</p>
            <ul>
                <li>Согласие Пользователя</li>
                <li>Исполнение обязательств перед Пользователем</li>
                <li>Соблюдение требований законодательства</li>
            </ul>
        </div>

        <div className="section">
            <h2>5. Порядок и сроки хранения данных</h2>
            <p>Персональные данные хранятся:</p>
            <ul>
                <li>До тех пор, пока это необходимо для предоставления услуг</li>
                <li>В соответствии с требованиями законодательства</li>
                <li>В зашифрованном и защищённом виде</li>
            </ul>
        </div>

        <div className="section">
            <h2>6. Права и обязанности сторон</h2>
            
            <h3>6.1 Права Пользователя:</h3>
            <ul>
                <li>Получать информацию о своих данных</li>
                <li>Требовать исправления, удаления или блокировки данных</li>
                <li>Отзывать своё согласие на обработку</li>
                <li>Отказаться от использования Сервиса, прекратив обработку данных</li>
            </ul>

            <h3>6.2 Обязанности Оператора:</h3>
            <ul>
                <li>Принимать меры защиты данных от несанкционированного доступа</li>
                <li>Обеспечивать условия для реализации прав Пользователя</li>
                <li>Публиковать настоящую Политику</li>
            </ul>
        </div>

        <div className="section">
            <h2>7. Передача данных третьим лицам</h2>
            <p>Openway не передаёт персональные данные третьим лицам, за исключением:</p>
            <ul>
                <li>Платёжных систем, участвующих в обработке платежей</li>
                <li>Случаев, предусмотренных законодательством</li>
                <li>Ситуаций, когда Пользователь дал отдельное согласие на передачу данных</li>
            </ul>
            <p>Данные, которые обрабатываются сторонними сервисами, хранятся и обрабатываются ими в соответствии с их политиками конфиденциальности.</p>
        </div>

        <div className="section">
            <h2>8. Меры безопасности</h2>
            <p>Мы применяем правовые, организационные и технические меры для защиты персональных данных от:</p>
            <ul>
                <li>Утраты</li>
                <li>Несанкционированного доступа</li>
                <li>Изменения</li>
                <li>Распространения</li>
            </ul>
        </div>

        <div className="section">
            <h2>9. Трансграничная передача данных</h2>
            <p>При необходимости передать персональные данные за пределы РФ мы руководствуемся действующим законодательством и уведомляем компетентные органы, если это требуется.</p>
        </div>

        <div className="section">
            <h2>10. Изменение политики</h2>
            <p>Openway оставляет за собой право вносить изменения в настоящую Политику в любое время. Новая версия вступает в силу с момента публикации на сайте или другой площадке, где она размещена.</p>
        </div>

        <div className="contact-info">
            <h2>11. Контактная информация</h2>
            <p><strong>Telegram:</strong> <a href={HelpLink} target="_blank" rel="noreferrer">{HelpLink}</a></p>
        </div>

        <div className="footer-note">
            <p>© 2026 Openway. Все права защищены.</p>
        </div>
        <Button className={styles.btn} label="Назад" onClick={() => handleClickPrevPage()}></Button>
    </DocumentPage>
  );
}

export default PrivacePolicyPage;